import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth token lives in a module-scoped closure — memory-only. Kept out of
// localStorage/sessionStorage so a stored XSS payload can't exfiltrate it.
// AuthContext calls setAuthToken() to install a token after a successful
// sign-in; a page reload wipes the token by design (user re-verifies).
let _authToken = null;
export function setAuthToken(token) {
  _authToken = token || null;
}
export function getAuthToken() {
  return _authToken;
}

// Admin token gets identical treatment. sessionStorage would leak it to
// any script in the tab; keeping it in memory means a reload forces the
// admin to re-enter their token — an acceptable trade for zero XSS
// exfiltration surface on a higher-privilege credential.
let _adminToken = null;
export function setAdminToken(token) {
  _adminToken = token || null;
}
export function getAdminToken() {
  return _adminToken;
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  if (_authToken) config.headers.Authorization = `Bearer ${_authToken}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
